/* istanbul ignore file */
import { ProjectToolMessageCallback } from 'domain/projects/shared/projectToolsCreation';

const useCreateTeamsResponseHandler = () => {
  const handleCreationStatus = (creationStatus: any, callback: ProjectToolMessageCallback) => {
    if (creationStatus.isCreated) {
      callback({ type: 'log', level: 'success', message: 'Successfully created Team.' });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to create Team due to: ${creationStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleFoundStatus = (foundStatus: any, callback: ProjectToolMessageCallback) => {
    if (foundStatus.isFound) {
      callback({ type: 'log', level: 'success', message: 'Successfully found Team.' });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to find Team due to: ${foundStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleProjectUpdateLinksStatus = (projectUpdateStatus: any, callback: ProjectToolMessageCallback) => {
    if (projectUpdateStatus.isUpdated) {
      callback({ type: 'log', level: 'success', message: 'Successfully updated Project link to the Team.' });
      return true;
    } else {
      callback({
        type: 'log',
        level: 'error',
        message: `Failed to update Project link to the Team due to: ${projectUpdateStatus.errors.join(' ')}.`,
      });
      return false;
    }
  };

  const handleTeamsResponse = (state: any, callbackFunction: ProjectToolMessageCallback) => {
    let isPassed = true;

    if (state.teamsCreationStatus) {
      isPassed = handleCreationStatus(state.teamsCreationStatus, callbackFunction) && isPassed;
    }
    if (state.teamsFoundStatus) {
      isPassed = handleFoundStatus(state.teamsFoundStatus, callbackFunction) && isPassed;
    }
    if (state.projectFieldUpdatedStatus) {
      isPassed = handleProjectUpdateLinksStatus(state.projectFieldUpdatedStatus, callbackFunction) && isPassed;
    }

    callbackFunction({ type: 'status', status: isPassed ? 'passed' : 'failed' });
  };

  return {
    handleTeamsResponse,
  };
};

export default useCreateTeamsResponseHandler;
